import React , {useState } from "react";
import { useSelector } from 'react-redux';
import 'moment/locale/es';
import { Button, Card, CardHeader, CardBody, Form, Row, Col, } from "reactstrap";

import Select from "react-select";

import './CourseEnroll.css';

var Icons = require ('Icons') ;


export const  CourseEnrollSubject = ( { enroleSubject, unenroled,  closeMe  } ) => {

  const [selectedValue, setSelectedValue] = useState(null);
 
  const { course, token, isSaving } = useSelector(state => ({
    currentCalendarID: state.school.currentCalendarID,
    token: state.auth.session.jwt_token, 
    course: state.courses.course,
    isSaving: state.view.loadingModules.enrollingStudent 

   }))

    // handle input change event
    const handleInputChangeSelect = value => {
      setSelectedValue(value);
    };


 

  const confirmEnroll = () => {
    if (selectedValue) { 
      enroleSubject (token, course.course_id, selectedValue.value)
      closeMe(false)
    }
  }


    // load options using API call
    // const loadOptions = (inputValue) => {
    //   if (inputValue.length >= 3 ) return courseApi.getUnroledStudents ( token, currentCalendarID, inputValue ).then(res => res );
    // };

        return (
          
        <>
        <Card>
                <CardHeader>
                  <Row>
                    <Col className="pr-1" md="12">
                      <h5 className="title">Agregar materia al curso {course.name} - {course.shift_name}</h5>
                    </Col>
                  </Row>
                </CardHeader>
                
                <CardBody>
                  <Form>
                    <Row>
                      <Col  md="8">
                      <Select 
                                  className="select-subject"
                                  name="course_id"
                                  isSearchable={true}
                                  onChange={handleInputChangeSelect}
                                  options={unenroled}
                                  placeholder="buscar materia..."
                              />    
                     </Col>
                      <Col md="2">
                          <Button color="success" disabled={!selectedValue} style={{width: "100%" }} 
                            onClick={() => confirmEnroll()}>
                            {isSaving?
                              <i className="nc-icon nc-refresh-69  fa-spin" />
                            :
                            <>
                             <i className={Icons.CHECK} />
                            </>
                            }
                          </Button>
                      </Col>
                      <Col   md="2">
                          <Button color="danger" disabled={isSaving} style={{width: "100%" }} 
                            onClick={() => closeMe(false) }>
                             <i className={Icons.CANCEL} />
                          </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              </>
          );
    }

    // 